<template>
  <div class="schedule-load">
    <el-form :inline="true" :model="q" size="small">
      <el-form-item label="车间">
        <el-select v-model="q.workShopId" clearable filterable placeholder="全部" style="width:160px">
          <el-option v-for="w in workShops" :key="w.workShopId" :label="w.workShopName" :value="w.workShopId" />
        </el-select>
      </el-form-item>
      <el-form-item label="期间起"><el-date-picker v-model="q.rangeStart" type="date" value-format="yyyy-MM-dd" /></el-form-item>
      <el-form-item label="期间止"><el-date-picker v-model="q.rangeEnd" type="date" value-format="yyyy-MM-dd" /></el-form-item>
      <el-form-item><el-button type="primary" @click="load">查询</el-button></el-form-item>
    </el-form>
    <div class="load-bars" v-loading="loading">
      <div v-for="row in list" :key="row.workCenterId" class="load-bar-row">
        <div class="load-bar-label">{{ row.workCenterCode }} {{ row.workCenterName }}</div>
        <div class="load-bar-track">
          <div class="load-bar-fill" :class="{ over: row.overloadFlag === '1' }" :style="{ width: barWidth(row) }" />
          <span class="load-bar-text">{{ formatRate(row) }}</span>
        </div>
      </div>
      <div v-if="!loading && !list.length" class="empty">暂无机台负荷数据</div>
    </div>
    <el-table :data="list" border size="small" style="margin-top:12px">
      <el-table-column prop="workShopName" label="车间" min-width="100" />
      <el-table-column prop="workCenterCode" label="机台编码" width="110" />
      <el-table-column prop="workCenterName" label="机台名称" min-width="120" />
      <el-table-column prop="parallelQty" label="并行数" width="70" align="right" />
      <el-table-column prop="loadHours" label="负荷(h)" width="90" align="right" />
      <el-table-column prop="availableHours" label="可用(h)" width="90" align="right" />
      <el-table-column label="负荷率" width="90" align="right">
        <template slot-scope="s">{{ formatRate(s.row) }}</template>
      </el-table-column>
      <el-table-column label="超载" width="70" align="center">
        <template slot-scope="s">
          <el-tag v-if="s.row.overloadFlag==='1'" type="danger" size="mini">超载</el-tag>
          <span v-else>—</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { getScheduleCenterLoad } from '../../api/production/productionOrder'
import request from '../../api/request'

function today() {
  const d = new Date()
  const p = n => String(n).padStart(2, '0')
  return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate())
}

function nextDay(day) {
  const date = new Date(day + 'T00:00:00')
  date.setDate(date.getDate() + 1)
  const p = n => String(n).padStart(2, '0')
  return date.getFullYear() + '-' + p(date.getMonth() + 1) + '-' + p(date.getDate())
}

export default {
  name: 'ProductionScheduleLoad',
  data() {
    return {
      q: { workShopId: '', rangeStart: today(), rangeEnd: '' },
      workShops: [], list: [], loading: false
    }
  },
  created() { this.loadWorkShops(); this.load() },
  methods: {
    loadWorkShops() {
      request.get('/base/workShop/selectEnabled').then(res => { this.workShops = res.data || [] }).catch(() => {})
    },
    formatRate(row) {
      if (row.loadRate == null && Number(row.loadHours) > 0) return '无可用工时'
      if (row.loadRate == null) return '—'
      return (Number(row.loadRate) * 100).toFixed(1) + '%'
    },
    barWidth(row) {
      if (row.loadRate == null && Number(row.loadHours) > 0) return '100%'
      const pct = Math.min(160, Number(row.loadRate || 0) * 100)
      return pct + '%'
    },
    load() {
      if (this.q.rangeStart && this.q.rangeEnd && this.q.rangeEnd < this.q.rangeStart) {
        this.$message.warning('期间止不能早于期间起')
        return
      }
      this.loading = true
      getScheduleCenterLoad({
        workShopId: this.q.workShopId,
        rangeStart: this.q.rangeStart ? this.q.rangeStart + ' 00:00:00' : null,
        rangeEnd: this.q.rangeEnd ? nextDay(this.q.rangeEnd) + ' 00:00:00' : null
      }).then(res => {
        this.list = Array.isArray(res.data) ? res.data : []
      }).catch(() => { this.list = [] }).finally(() => { this.loading = false })
    }
  }
}
</script>

<style scoped>
.load-bars { min-height: 80px; }
.load-bar-row { display: flex; align-items: center; margin-bottom: 8px; }
.load-bar-label { width: 180px; font-size: 12px; color: #606266; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.load-bar-track { flex: 1; height: 22px; background: #f5f7fa; border-radius: 3px; position: relative; overflow: hidden; }
.load-bar-fill { height: 100%; background: #409eff; border-radius: 3px; }
.load-bar-fill.over { background: #f56c6c; }
.load-bar-text { position: absolute; right: 8px; top: 0; line-height: 22px; font-size: 12px; color: #303133; }
.empty { padding: 16px; text-align: center; color: #909399; }
</style>
